// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3zgPG","checkboxCol":"Table_checkboxCol__1Regt","emailCol":"Table_emailCol__1CZlC","actionCol":"Table_actionCol__1S-yO"};